import { cn } from "@/lib/utils";

interface GradientTextProps {
  children: React.ReactNode;
  /** "purple" (default) | "green" */
  variant?: "purple" | "green";
  className?: string;
  as?: React.ElementType;
}

export default function GradientText({
  children,
  variant = "purple",
  className,
  as: Tag = "span",
}: GradientTextProps) {
  return (
    <Tag className={cn(variant === "green" ? "gradient-text-green" : "gradient-text", className)}>
      {children}
    </Tag>
  );
}
